import { createFileRoute, redirect } from '@tanstack/react-router'

// Dropify only serves resellers now, not dropshippers. This route stays only
// to 301 the indexed URL and inbound links to the reseller page.
export const Route = createFileRoute('/cara-jadi-dropshipper')({
  loader: () => {
    throw redirect({ href: '/cara-jadi-reseller', statusCode: 301 })
  },
})
